<template>
    <section>
      <div class="container my-5" data-aos="fade-up" data-aos-duration="3000">
        <div class="position-relative p-5 text-center text-muted bg-body border border-dashed rounded-5">
          <img src="images/Service_icon.png"  width="80" style="margin-top: 20px;">
          <h1 class="text-body-emphasis">Services</h1>
          <p class="col-lg-6 mx-auto mb-4">
            Starting a business is tough enough without technical glitches or paperwork nightmares. You need a partner who understands your challenges and is there to support you every step of the way.
          </p>
          <div class="row">
            <div class="col-lg-4">
              <img src="images/setting.png" width="100">
              <h2 class="fw-normal">IT Solution</h2>
              <p>Help clients assess different technology strategies and, in doing so, align their technology strategies with their business or process strategies.</p>
            </div><!-- /.col-lg-4 -->
            <div class="col-lg-4">
              <img src="images/truck.png" width="100">
              <h2 class="fw-normal">Goods Exportation</h2>
              <p>Navigating the complexities of international trade can be daunting. But with the right tools, you can streamline the process and boost your exports.</p>
            </div><!-- /.col-lg-4 -->
            <div class="col-lg-4">
              <img src="images/business.png" width="100">
              <h2 class="fw-normal">Business Registration</h2>
              <p>Advice on requirements, rights and obligations during and after approval of your business registration, ensuring a smooth and efficient registration process.</p>
            </div><!-- /.col-lg-4 -->
          </div>
        </div>
        </div>
    </section>
</template>